import { FEATURE_FLAGS } from './feature-flags'
import * as z from 'zod'

export type Settings = z.infer<typeof SettingsSchema>

/**
 * This schema isn't full, so can be updated based on features we'd like to handle and include in settings.
 */
export const StrictSettingsSchema = z.object({
  flags: z.array(z.union([z.enum(FEATURE_FLAGS), z.string()])),
  email: z.string().optional(),
})

/**
 * flags is an array of feature flags + any strings, because we can't guarantee the type of the flags.
 */
export const SettingsSchema = StrictSettingsSchema.merge(
  z.object({
    flags: z.array(z.union([z.enum(FEATURE_FLAGS), z.string()])),
  }),
)
